const API_BASE_URL =
  process.env.REACT_APP_API_URL || "http://localhost:4000/api";

export async function getTenantIntentContext(token) {
  const res = await fetch(
    `${API_BASE_URL}/public/tenant-intent/${encodeURIComponent(token)}`
  );
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || "Could not load this page");
  }
  return data;
}

export async function postTenantIntentRenewal(token) {
  const res = await fetch(
    `${API_BASE_URL}/public/tenant-intent/${encodeURIComponent(
      token
    )}/request-renewal`,
    { method: "POST", headers: { "Content-Type": "application/json" } }
  );
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || "Could not submit renewal request");
  }
  return data;
}

export async function postTenantIntentNotice(token) {
  const res = await fetch(
    `${API_BASE_URL}/public/tenant-intent/${encodeURIComponent(
      token
    )}/give-notice`,
    { method: "POST", headers: { "Content-Type": "application/json" } }
  );
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || "Could not record notice");
  }
  return data;
}
